import { css } from "@emotion/react";
import { useLocation } from "react-router-dom";
import { _PostAuthorization } from "./_authorize/_post-authorization";
import { _PreAuthorization } from "./_authorize/_pre-authorization";

export const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    overflow-y: hidden;
    height: 88px;
    justify-content: space-around;
  `,
};

interface IProps {
  appName: string;
}

const Authorize = ({ appName }: IProps) => {
  const { hash } = useLocation();
  const token = hash.match(/(?<=token=)\w+/)?.[0];

  if (token) return <_PostAuthorization token={token} />;

  return <_PreAuthorization appName={appName} />;
};

export default Authorize;
